import { ThemeProvider } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Hidden from 'app/shared/mui/Hidden';
import Toolbar from '@mui/material/Toolbar';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectFuseCurrentLayoutConfig, selectToolbarTheme } from 'app/store/fuse/settingsSlice';
import UserCart from 'app/theme-layouts/shared-components/UserCart';
import AdjustFontSize from '../../shared-components/AdjustFontSize';
import FullScreenToggle from '../../shared-components/FullScreenToggle';
import LanguageSwitcher from '../../shared-components/LanguageSwitcher';
import NavigationShortcuts from '../../shared-components/NavigationShortcuts';
import NavigationSearch from '../../shared-components/NavigationSearch';
import NavbarToggleButton from '../../shared-components/NavbarToggleButton';
import UserMenu from '../../shared-components/UserMenu';
import AppVersion from 'app/shared-components/AppVersion';
import NotificationPanelToggleButton from '../../shared-components/notificationPanel/NotificationPanelToggleButton';
import { navbarToggleIcon, notificationToggleIcon } from '../../shared-components/toolbarDefaultIcons';
import { isInventoryLookupUser } from 'app/auth/roleHome';

function ToolbarLayout2(props) {
  const config = useSelector(selectFuseCurrentLayoutConfig);
  const toolbarTheme = useSelector(selectToolbarTheme);
  const currentUser = useSelector(({ user }) => user);
  const navigate = useNavigate()
  const isCustomer = currentUser && currentUser.role === 'customer';
  // PGSS-5715: an Inventory Lookup login has one page -- no shortcuts, search, notifications or cart.
  const lookupOnly = isInventoryLookupUser(currentUser);

  return (
    <ThemeProvider theme={toolbarTheme}>
      <AppBar
        id="fuse-toolbar"
        className={clsx('flex relative z-20 shadow-md', props.className)}
        color="default"
        style={{ backgroundColor: toolbarTheme.palette.background.paper }}
      >
        <Toolbar className="container p-0 lg:px-24 min-h-48 md:min-h-64">
          {config.navbar.display && (
            <Hidden lgUp>
              <NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8">
                {navbarToggleIcon}
              </NavbarToggleButton>
            </Hidden>
          )}

          <div className="flex flex-1">
            {!lookupOnly && (
              <Hidden lgDown>
                <NavigationShortcuts />
              </Hidden>
            )}
          </div>

          <div className="flex items-center px-8 h-full overflow-x-auto">
            <LanguageSwitcher />

            <AdjustFontSize />

            <FullScreenToggle />

            {!lookupOnly && <NavigationSearch />}

            {!lookupOnly && (
              <NotificationPanelToggleButton
                onClick={() => navigate(`/notifications?refresh=${Math.floor(10000000 + Math.random() * 90000000)}`)}
              >
                {notificationToggleIcon}
              </NotificationPanelToggleButton>
            )}

            {isCustomer && !lookupOnly && <UserCart />}

            {/* PGSS-5442: in the toolbar, not the footer. Both production layouts set
                footer.display=false, so anything mounted there is never seen by a
                signed-in user. The toolbar is on every screen for every role. */}
            <AppVersion className="mx-8" />
            <UserMenu />
          </div>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
}

export default memo(ToolbarLayout2);
